import { connect } from 'react-redux'

import UniversalMenuPreview from '@components/groupOrders/UniversalMenuPreview/UniversalMenuPreview'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'
import { AdminUser } from '@types'

type ReduxState = {
  user: AdminUser
}

const mapStateToProps = (state: ReduxState) => {
  const { user } = state
  const { lastLoggedInHq } = user

  return {
    hqId: lastLoggedInHq,
  }
}

const mapDispatchToProps = () => {
  const { GroupOrdersService, RestService, UIService } = services
  const { SearchClientSettings, SearchUniversalPreviewMenus } = coordinators
  const {
    pRequestSearchGOMenusParams,
    pResponseGOMenus,
    pResponseGroupOrderClientSettings,
  } = presenters.Api

  const searchGOMenus = SearchUniversalPreviewMenus({
    RestService,
    pRequestSearchGOMenusParams,
    pResponseGOMenus: pResponseGOMenus as any,
    HandleError,
  })

  const searchClientSettings = SearchClientSettings({
    RestService,
    GroupOrdersService,
    HandleError,
    pResponseGroupOrderClientSettings,
  })

  const { displayFailureMessage } = UIService.FlashMessage
  const { displayInfoModal: showCustomModal, dismissInfoModal } =
    UIService.InfoModal

  return {
    displayFailureMessage,
    dismissInfoModal,
    searchGOMenus,
    searchClientSettings,
    showCustomModal,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UniversalMenuPreview)
